// Meta Pixel (Facebook Pixel) utilities for tracking events
// Make sure to replace 'YOUR_PIXEL_ID' in index.html with your actual Meta Pixel ID

declare global {
  interface Window {
    fbq: any;
  }
}

// Check if Meta Pixel is loaded
export const isMetaPixelLoaded = (): boolean => {
  return typeof window !== 'undefined' && typeof window.fbq === 'function';
};

// Track page view
export const trackPageView = (page?: string): void => {
  if (isMetaPixelLoaded()) {
    window.fbq('track', 'PageView', page ? { page } : {});
  }
};

// Track custom events
export const trackEvent = (eventName: string, parameters?: Record<string, any>): void => {
  if (isMetaPixelLoaded()) {
    window.fbq('track', eventName, parameters || {});
  }
};

// Track standard events
export const trackViewContent = (contentType?: string, contentId?: string): void => {
  if (isMetaPixelLoaded()) {
    window.fbq('track', 'ViewContent', {
      content_type: contentType || 'page',
      content_ids: contentId ? [contentId] : []
    });
  }
};

export const trackLead = (value?: number, currency?: string): void => {
  if (isMetaPixelLoaded()) {
    const params: Record<string, any> = {};
    if (value) params.value = value;
    if (currency) params.currency = currency;
    window.fbq('track', 'Lead', params);
  }
};

export const trackCompleteRegistration = (value?: number, currency?: string): void => {
  if (isMetaPixelLoaded()) {
    const params: Record<string, any> = {};
    if (value) params.value = value;
    if (currency) params.currency = currency;
    window.fbq('track', 'CompleteRegistration', params);
  }
};

export const trackInitiateCheckout = (value?: number, currency?: string, numItems?: number): void => {
  if (isMetaPixelLoaded()) {
    const params: Record<string, any> = {};
    if (value) params.value = value;
    if (currency) params.currency = currency;
    if (numItems) params.num_items = numItems;
    window.fbq('track', 'InitiateCheckout', params);
  }
};

export const trackPurchase = (value: number, currency: string = 'INR', contentIds?: string[]): void => {
  if (isMetaPixelLoaded()) {
    window.fbq('track', 'Purchase', {
      value,
      currency,
      content_ids: contentIds || []
    });
  }
};

export const trackAddToCart = (value?: number, currency?: string, contentId?: string): void => {
  if (isMetaPixelLoaded()) {
    const params: Record<string, any> = {};
    if (value) params.value = value;
    if (currency) params.currency = currency;
    if (contentId) params.content_ids = [contentId];
    window.fbq('track', 'AddToCart', params);
  }
};

export const trackSearch = (searchString: string, value?: number, currency?: string): void => {
  if (isMetaPixelLoaded()) {
    const params: Record<string, any> = {
      search_string: searchString
    };
    if (value) params.value = value;
    if (currency) params.currency = currency;
    window.fbq('track', 'Search', params);
  }
};

// Track custom events specific to your stock market app
export const trackStockView = (stockSymbol: string, stockPrice?: number): void => {
  trackEvent('ViewStock', {
    stock_symbol: stockSymbol,
    stock_price: stockPrice
  });
};

export const trackPredictionView = (predictionType: string, stockSymbol?: string): void => {
  trackEvent('ViewPrediction', {
    prediction_type: predictionType,
    stock_symbol: stockSymbol
  });
};

export const trackSignupAttempt = (method: string): void => {
  trackEvent('SignupAttempt', {
    signup_method: method
  });
};

export const trackFeatureUsage = (featureName: string): void => {
  trackEvent('FeatureUsage', {
    feature_name: featureName
  });
};

export const trackBlogPostView = (postTitle: string, category?: string): void => {
  trackEvent('BlogPostView', {
    post_title: postTitle,
    category: category
  });
};
